import axios from "axios";
import { collaborationUrl } from "../../../utils";

export const fetchCollaboration = async (collaborationId: string) => {
  return axios.get(collaborationUrl(collaborationId));
};
